import { BrowserRouter } from "react-router-dom";
import { Providers } from "./app/Providers";
import { AppRoutes } from "./app/AppRoutes";
import { AnalyticsTracker } from "./app/AnalyticsTracker";
import { ScrollToTop } from "./app/ScrollToTop";
import { CookieConsent } from "./components/CookieConsent";

const App = () => (
  <Providers>
    <BrowserRouter>
      <AnalyticsTracker />
      <ScrollToTop />
      <AppRoutes />
      <CookieConsent />
    </BrowserRouter>
  </Providers>
);

export default App;
